export default service => ({
  durationHour: Math.floor(service.duration / 60),
  durationMinute: service.duration % 60,
});
